import React, { useContext, useState, useEffect, useRef } from "react"
import useGlobal from "../../context/GlobalContext"
import { navigate } from "gatsby"
import CurrencyContext from "../../context/CurrencyContext"

export default function LanguageToggle() {
  const { languageOptions, pageContext } = useGlobal()
  const { chooseMe } = useContext(CurrencyContext)

  const [dropdownOpen, setDropdownOpen] = useState(false)
  const dropdownRef = useRef(null)

  // Mapping between language and currency
  const languageCurrencyMap = {
    "en-in": "INR",
    "en-us": "USD",
    "en-uk": "GBP",
  }

  // Get current language label
  const currentLanguage = languageOptions.find(
    (item) =>
      item.value === pageContext.langKey || item.lang === pageContext.langKey
  )

  const toggleDropdown = () => setDropdownOpen((prev) => !prev)
  const closeDropdown = () => setDropdownOpen(false)

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        closeDropdown()
      }
    }
    document.addEventListener("mousedown", handleClickOutside)
    return () => document.removeEventListener("mousedown", handleClickOutside)
  }, [])

  function handleNavigate(item) {
    const newCurrency = languageCurrencyMap[item.value]
    if (newCurrency) {
      chooseMe({ value: newCurrency })
    }

    if (item.value === "en-in") {
      navigate(pageContext.url)
    } else {
      navigate(`/${item.value}${pageContext.url}`)
    }

    setTimeout(() => window.scrollTo(0, 0), 100)
    closeDropdown()
  }

  return (
    <li className="nav-item dropdown langauge-dropdown" ref={dropdownRef}>
      <button
        className="btn btn-secondary dropdown-toggle"
        type="button"
        onClick={toggleDropdown}
        aria-expanded={dropdownOpen}
      >
        {currentLanguage?.label || "Select Language"}
      </button>
      {dropdownOpen && (
        <ul className="dropdown-menu show">
          {languageOptions.map((item, index) => (
            <li key={index}>
              <button
                className="dropdown-item"
                onClick={() => handleNavigate(item)}
              >
                {item.label}
              </button>
            </li>
          ))}
        </ul>
      )}
    </li>
  )
}
